import type { EditorPlugin } from '../../types/aha-editor';

const WritingAssistantPlugin: EditorPlugin[] = [
  {
    name: 'Writing assistant plugin',
  },
];

export default WritingAssistantPlugin;
